export default "__VITE_ASSET__BRvfvMtM__"